module.exports = __webpack_public_path__ + "static/media/environmentally-conscious-landing.82712721.jpg";